export default __webpack_public_path__ + "static/media/new-check-circle.0ec796c5.svg";